import colors from './js/colors.js';
import privateSignal from './js/privateSignal.js';
window.FColorToRGB = new colors();
window.privateSignal = privateSignal;
window.FC_PI = 3.1415926535897;
//window.AsyncFunction = Object.getPrototypeOf(async function(){}).constructor;
//将整型时间转成字符串形式
Date.prototype.format = function(format) {
    var date = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1
                ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
    }
    return format;
}
/*16进制颜色转为RGB格式*/  
String.prototype.colorRgb = function(opacity){
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var sColor = this.toLowerCase();
    if(sColor && reg.test(sColor)){
        if(sColor.length === 4){
            var sColorNew = "#";
            for(var i=1; i<4; i+=1){
                sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
            }
            sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for(var i=1; i<7; i+=2){
            sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
        }
        if(opacity){
            return "RGBA(" + sColorChange.join(",") +","+ opacity + ")";
        }else{
            return sColorChange;
        }
    }else{
        return sColor;
    }};

/*RGB颜色转换为16进制*/
String.prototype.colorHex = function(){
    var that = this;
    if(/^(rgb|RGB)/.test(that)){
        var aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g,"").split(",");
        var strHex = "#";
        for(var i=0; i<aColor.length; i++){
            var hex = parseInt(aColor[i]).toString(16);
            //if(hex === "0"){
            //    hex += hex;
            //}
            if(hex.length==1){
                strHex += "0" + hex;
            }else{
                strHex += hex;
            }

        }
        if(strHex.length !== 7){
            strHex = that;
        }
        return strHex;
    }else if(reg.test(that)){
        var aNum = that.replace(/#/,"").split("");
        if(aNum.length === 6){
            return that;
        }else if(aNum.length === 3){
            var numHex = "#";
            for(var i=0; i<aNum.length; i+=1){
                numHex += (aNum+aNum);
            }
            return numHex;
        }
    }else{
        return that;
    }
};
//以秒为单位增加日期
Date.prototype.AddSecond = function(s){
    var Milliseconds = this.getTime();//h毫秒
    return new Date(Milliseconds + s * 1000);
}
window.showAllTags = function(){
    console.log(window.__dbTags)
}
window.showAllMidTags = function(){
    console.log(window.__systemMidVar)
}
window.isApp = function(){
	var ua = navigator.userAgent;
	var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
		isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
		isAndroid = ua.match(/(Android)\s+([\d.]+)/),
		isMobile = isIphone || isAndroid;
	if(isMobile) {
		return true;
	}else{
		return false;
	}
}
//字体的pt单位换算为px
window.PtToPx = function(value){
    return value / 72 * 96;
}



// WEBPACK FOOTER //
// ./src/js/script/fvGlobal.js